export enum BroadcastMessageType {
	organizationChanged = 'organization-change',
}

export interface IBroadcastMessage {
	type: string;
	payload: any;
}
